/**
 * Application-wide constants
 * Centralizes magic numbers and strings for maintainability
 */

// Timing constants
export const TIMING = {
  /** Debounce delay for URL input (ms) */
  URL_DEBOUNCE: 300,
  
  /** Auth initialization timeout (ms) */
  AUTH_INIT_TIMEOUT: 5000,
  
  /** Preview fetch timeout (ms) */
  PREVIEW_FETCH_TIMEOUT: 20000,
  
  /** Token refresh threshold (seconds before expiry) */
  TOKEN_REFRESH_THRESHOLD: 60,
} as const;

// Validation constants
export const VALIDATION = {
  /** Allowed URL protocols */
  ALLOWED_PROTOCOLS: ['http:', 'https:'] as const,
  
  /** Maximum list capacity */
  MAX_LIST_COLLABORATORS: 50,
  
  /** Rate limit: invitations per hour */
  MAX_INVITATIONS_PER_HOUR: 10,
  
  /** Invitation expiry (days) */
  INVITATION_EXPIRY_DAYS: 7,
} as const;

// UI constants
export const UI = {
  /** Toast display duration (ms) */
  TOAST_DURATION: 3000,
  
  /** Modal animation duration (ms) */
  MODAL_ANIMATION: 200,
} as const;

// Status values
export const STATUS = {
  PENDING: 'pending' as const,
  IN_PROGRESS: 'in_progress' as const,
  COMPLETED: 'completed' as const,
  CANCELLED: 'cancelled' as const,
};

// Item status values (for type safety)
export const ITEM_STATUS = {
  WANT: 'want' as const,
  PURCHASED: 'purchased' as const,
  RECEIVED: 'received' as const,
} as const;

export type ItemStatusValue = typeof ITEM_STATUS[keyof typeof ITEM_STATUS];
